import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType } from "__generated__/graphql";

export const DeadfreightSchema: RegistryItem = {
	[AgreementTypeEnum.Deadfreight]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.Manual,
			},
		},
		agreementFields: {
			"agreement.description": { rules: { hidden: true } },
			"agreement.costType": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
		},
	},
};
